<template>

<component :is="($isMobile) ? 'portal' : 'div'" to="top">

<div 
	class="dropdown-list" 
	:key="key"
	:style="{marginTop: marginTop}" 
	v-touch:swipe.right="onSwipe" 
	v-propagation 
	v-bind:class="{
		'align-left': align === 'left', 
		'is-inline': inline, 
		'align-right': align === 'right', 
		'is-caret': caret, 
		'is-levels': levels, 
		[themeClass]: theme, 
		'is-expanded': expanded
	}"
>

	<div class="dropdown-list-title" v-if="$isMobile && title">{{ title }}</div>

	<core-button v-if="$isMobile" v-on:click.native.stop.prevent="onCloseClick" theme="filter" :icon="icon || 'caret-left'" :iconOnly="true" class="dropdown-list-close" />

	<div class="dropdown-list-content">

		<slot></slot>

	</div>

</div>

</component>

</template>

<script>

export default {

	props: ['expanded', 'inline', 'align', 'title', 'icon', 'caret', 'theme', 'levels'],

	data: function() {

		return {
			key: ''
		}

	},
	
	created: function() {

		this.key = this.$util.key()

	},

	computed: {

        marginTop: function() {

			if (this.$isDesktop) return false

            var offset = (0 - this.window.scrollY)

            if (offset < -40) offset = -40

            return offset.toString() + 'px'

        },

		themeClass: function() {

			return 'theme-' + this.theme

		}

	},

	methods: {

		onSwipe: function() {

			if (this.window.is.mobile) {

				this.onCloseClick()

			}

		},

		onCloseClick: function() {

			this.$nextTick(function() {

				this.$emit('close')

			}.bind(this))

		}

	}
	
}

</script>

<style scoped>

.dropdown-list:not(.is-inline) {
	position: absolute;
	background-color: #316293;
	padding: 6px 0px;
	z-index: 100;
	display: none;
	white-space: nowrap;
	transition: all 300ms ease-in-out;
}

.dropdown-list-title {
	font-size: 14px;
	position: absolute;
	font-weight: 500;
	left: 8px;
	color: #343434;
	letter-spacing: 1px;
	text-transform: uppercase;
	top: 10px;
	line-height: 32px;
}

.is-mobile .dropdown-list-title {
	color: #fff;
    font-family: 'Barlow', sans-serif;
	text-transform: initial;
    letter-spacing: 1px;
    font-weight: 700;
    font-size: 16px;
}

.dropdown-list-close.button.theme-filter {
	position: absolute;
	right: 10px;
	top: 10px;
}

.is-desktop .dropdown-list:not(.is-inline),
.is-tablet .dropdown-list:not(.is-inline) {
	top: 10px;
	right: 0px;
	min-width: 200px;
}

.is-desktop .dropdown-list.align-left:not(.is-inline),
.is-tablet .dropdown-list.align-left:not(.is-inline) {
	right: auto;
	left: 0px;
}

.is-mobile .dropdown-list {
	min-width: 100%;
	width: 100%;
}

.is-mobile .bar-right .dropdown-list {
	top: auto!important;
	max-height: calc(100% - 96px);
	overflow: auto;
}

.dropdown-list.is-levels {
	width: 220px;
}

.is-mobile .dropdown-list.is-levels {
	width: 100%;
}

.dropdown-list.is-expanded {
	display: block;
}

.dropdown-list.theme-cell {
	right: 0px;
	top: 100%;
}

.dropdown-list.theme-filter {
	width: auto;
	border-radius: 4px;
	padding: 4px 0px;
	background-color: #316293;
	z-index: 2000;
}

.dropdown-list.theme-head {
	right: -1px;
	width: auto;
	top: 70px;
	border-radius: 4px;
	padding: 4px 0px;
	background-color: #082534;
	z-index: 2000;
}

.is-mobile .dropdown-list.theme-head {
	top: 48px;
}

.dropdown-list.theme-expand {
	right: -1px;
	width: auto;
	top: 40px;
	border-radius: 0px 0px 4px 4px;
	padding: 4px 0px;
	background-color: #fff;
	z-index: 2000;
	text-align: center;
	color: #333;
}

.dropdown-list.theme-expand  >>> .dropdown-item.type-action {
	color: #333;
	text-align: center!important;
}

.is-mobile .dropdown-list.theme-expand  >>> .dropdown-item.type-action {
	text-align: left!important;
}

.is-mobile .dropdown-list.theme-filter {
	top: 144px;
	padding-top: 4px;
	border-radius: 0px;
}

.is-mobile .dropdown-list.theme-expand {
	top: 145px;
	padding-top: 4px;
	right: 0px;
	width: 100%;
}

.is-mobile .dropdown-list:not(.theme-cell) {
	position: fixed;
	left: 0px;
	bottom: 0px;
	z-index: 1000;
	overflow-y: scroll;
}

.dropdown-list.is-caret:after {
	content: ' ';
	position: absolute;
	top: -6px;
	right: 14px;
	width: 0;
	height: 0;
	border-style: solid;
	border-width: 0 6px 6px 6px;
	border-color: transparent transparent #316293 transparent;
}

.dropdown-list.align-left.is-caret:after {
	right: auto;
	left: 14px;
}

.dropdown-list.theme-head.is-caret:after {
	right: 34px;
	border-color: transparent transparent #082534 transparent;
}

.dropdown-list.theme-cell.is-caret:after {
	right: 18px;
}

.dropdown.align-left {
	left: 0px;
}

.dropdown.align-right {
	right: 0px;
}

.dropdown-list > .dropdown-item.type-divide:first-child,
.dropdown-list > .dropdown-item.type-divide:last-child {
	display: none;
}

.is-mobile .dropdown-list {
	position: fixed!important;
    transform: translateX(calc(100vw + 40px));
	right: auto !important;
	left: calc(100vw - 200px) !important;
    top: 40px!important;
    background-color: #2b5870;
	width: 200px!important;
	display: block!important;
    bottom: 0px!important;
    box-shadow: 0 7px 29px 0 rgba(100, 100, 111, .2);
	transition: transform 100ms linear;
	padding: 50px 0px 0px 0px!important;
	overflow: auto;
	min-width: auto!important;
	z-index: 600000000!important;
	user-select: none;
}

.is-mobile .dropdown-list.is-expanded {
	transform: translateX(0);
}

.is-mobile .dropdown-list-content >>> .sort-options-item-text,
.is-mobile .dropdown-list-content >>> .dropdown-item,
.is-mobile .dropdown-list-content >>> .family,
.is-mobile .dropdown-list-content >>> .tag,
.is-mobile .dropdown-list-content >>> .family .fa {
	color: #fff!important;
}

.is-mobile .dropdown-list >>> .dropdown-item:not(.type-title) {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	min-height: 40px;
	display: flex;
	align-items: center;
}

.is-mobile .dropdown-list >>> .dropdown-item.type-title {
	text-align: left;
	padding-bottom: 0px;
}

.is-mobile .dropdown-list-content >>> .dropdown-item:last-child {
	border-bottom: 0px;
}

.is-mobile .dropdown-list-content >>> .sort-options-item .fa {
	background-color:rgba(0, 0, 0, 0.15);
	color: #fff!important;
	width: 24px;
	height: 24px;
	margin: 3px;
	opacity: 1;
	line-height: 24px;
	border-radius: 50%;
}

.is-mobile .dropdown-list-content >>> .dropdown-item.type-divide {
	display: none;
}

</style>
